/**
 * Returns a safe, user-facing error message.
 * Prevents raw Supabase/Postgres errors from leaking schema details to users.
 */
export function getErrorMessage(err: unknown): string {
  if (!err) return "An unexpected error occurred. Please try again.";

  const raw =
    typeof err === "string"
      ? err
      : (err as { message?: string })?.message ?? "";

  // Map known Supabase / Postgres error patterns to friendly messages
  if (/duplicate key|unique constraint/i.test(raw)) {
    return "This record already exists.";
  }
  if (/foreign key|violates foreign key/i.test(raw)) {
    return "This action is not allowed because related records exist.";
  }
  if (/not null|null value/i.test(raw)) {
    return "A required field is missing.";
  }
  if (/permission denied|row-level security/i.test(raw)) {
    return "You don't have permission to perform this action.";
  }
  if (/jwt|auth|token/i.test(raw)) {
    return "Your session has expired. Please sign in again.";
  }
  if (/network|fetch|failed to fetch/i.test(raw)) {
    return "Network error. Please check your connection and try again.";
  }

  // Generic fallback — never expose raw DB/internal messages
  return "Something went wrong. Please try again.";
}
